import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const isWebViewIOS = () => {
  const ua = navigator.userAgent || '';
  return /iPhone|iPad|iPod/.test(ua) && window.ReactNativeWebView;
};

// 🔹 Register service worker + request permission only if supported AND not iOS WebView
if ("serviceWorker" in navigator && !isWebViewIOS()) {
  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js"
      );
      // console.log("✅ Service Worker registered:", registration);
    } catch (err) {
      console.error("❌ Service Worker registration failed:", err);
    }
  });
}


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
